import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, forkJoin, catchError, throwError } from 'rxjs';
import { CommonService } from 'src/app/services/common-services/common.service';
import { error } from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class LandingService {
  shopBaseUrl = environment.SHOP_BASE_URL;
  categoryDataSource = [
    `${this.shopBaseUrl}v1/categories/81`,
    `${this.shopBaseUrl}v1/categories/106`,
    `${this.shopBaseUrl}v1/categories/116`,
    `${this.shopBaseUrl}v1/categories/299`,
    `${this.shopBaseUrl}v1/categories/304`,
    `${this.shopBaseUrl}v1/categories/172`,
    `${this.shopBaseUrl}v1/categories/190`,
    `${this.shopBaseUrl}v1/categories/263`,
  ]
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
  ) {}

  private handleError(error: HttpErrorResponse) {
    console.log(error.error.message);
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(`Backend returned code ${error.status}, body was: `, error.error);
    }

    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
  requestDataSlider(): Observable<any>{
    let apiUrl = `${this.shopBaseUrl}slider`;
    return this.commonService.getData(apiUrl)
    .pipe(catchError(this.handleError));
  }
  requestDataPopularProduct(): Observable<any>{
    let apiUrl = `${this.shopBaseUrl}v1/products?limit=8&page=1`;
    return this.commonService.getData(apiUrl)
    .pipe(catchError(this.handleError));
  }
  public requestDataPopularCategory(): Observable<any[]> {
    let response1 = this.http.get(this.categoryDataSource[0]);
    let response2 = this.http.get(this.categoryDataSource[1]);
    let response3 = this.http.get(this.categoryDataSource[2]);
    let response4 = this.http.get(this.categoryDataSource[3]);
    let response5 = this.http.get(this.categoryDataSource[4]);
    let response6 = this.http.get(this.categoryDataSource[5]);
    let response7 = this.http.get(this.categoryDataSource[6]);
    let response8 = this.http.get(this.categoryDataSource[7]);

    return forkJoin([response1, response2, response3, response4, response5, response6, response7, response8]);
  }
}
